import { render, staticRenderFns } from "./video-play-model.vue?vue&type=template&id=7480e25c&scoped=true"
import script from "./video-play-model.vue?vue&type=script&lang=ts"
export * from "./video-play-model.vue?vue&type=script&lang=ts"
import style0 from "./video-play-model.vue?vue&type=style&index=0&id=7480e25c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480e25c",
  null
  
)

export default component.exports